const pagesRolesSetting = [
  {
    path: '/manage-pages-roles',
    name: 'ManagePagesRoles',
    component: () => import('./pages/manage-pages-roles.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
];
export default pagesRolesSetting;
